import React from 'react';
import TypingIndicator from './TypingIndicator';
import styles from './LoadingState.module.css';

interface LoadingStateProps {
  variant?: 'full-page' | 'inline';
  message?: string;
  className?: string;
}

export const LoadingState: React.FC<LoadingStateProps> = ({
  variant = 'full-page',
  message,
  className,
}) => {
  return (
    <div
      className={`${styles.loadingState} ${variant === 'full-page' ? styles.fullPage : styles.inline} ${className || ''}`}
    >
      <TypingIndicator />
      {message && <p className={styles.message}>{message}</p>}
    </div>
  );
};

export default LoadingState;
